const Textarea = {
  isComponent: el => el.tagName === 'TEXTAREA',
  extend: 'textarea',
  model: {
    defaults: Object.assign({}, {
      tagName: 'img',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'textarea',
        class: ['input', 'textarea']
      }
    })
  }
}

export default Textarea
